import React from 'react';
import InlineCircleLoader from "react/components/InlineCircleLoader";

const CircleLoader = React.memo(function CircleLoader({
	                                                      children,
	                                                      loadingPosition,
	                                                      fullScreen,
	                                                      size = 'big',//small|medium|big
	                                                      showLoaderAnimation = true
                                                      }) {

	return (
		<div className={`${fullScreen ? 'full_screen' : ''} center`}>
			{!!children &&
			<div className='loader_content'>
				{children}
			</div>
			}
			{showLoaderAnimation &&
			<div className='section'>
				<InlineCircleLoader
					size={size}
					showLoaderAnimation={showLoaderAnimation}
				/>
				{loadingPosition !== undefined &&
				<div className='progress'>
					<div className='determinate' style={{ width: `${loadingPosition * 100}%` }} />
				</div>
				}
			</div>
			}
		</div>
	);
});
export default CircleLoader;